// initial state
const state = () => ({
  media: [],
  avatar: null,
  images: null,
  images_not_verified: null,
});

// getters
const getters = {
  getMedia: state => {
    return state.media;
  },
  getAvatar: state => {
    return state.avatar;
  },
  getImages: state => {
    return state.images;
  },
  getImagesNotVerified: state => {
    return state.images_not_verified;
  },
};

// actions
const actions = {
  loadMedia({ commit }) {
    axios.get(zRoute('ajax.user.media.index'), this.form).then(response => {
      const media = response.data.data;

      commit('setMedia', media);

      commit('setAvatar', media.find((m) => {
        return m.collection_name === 'avatars';
      }));

      commit('setImages', media.filter((m) => {
        return m.collection_name !== 'avatars' && m.verified_at !== null;
      }));

      commit('setImagesNotVerified', media.filter((m) => {
        return m.collection_name !== 'avatars' && m.verified_at === null;
      }));
    });
  },
};

// mutations
const mutations = {
  setMedia: (state, media) => {
    state.media = media;
  },
  setAvatar: (state, media) => {
    state.avatar = media;
  },
  setImages: (state, media) => {
    state.images = media;
  },
  setImagesNotVerified: (state, media) => {
    state.images_not_verified = media;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
